// Google Maps integration for ActiveAdmin
function initMap() {
  const mapElement = document.querySelector('#google-map')
  if (!mapElement) return

  // Wait for Google Maps and gmaps4rails to be available
  if (typeof google === 'undefined' || typeof Gmaps === 'undefined') {
    // Retry after a short delay if not yet loaded
    setTimeout(initMap, 100)
    return
  }

  function addProspectedAreaPolygons(prospectedAreaPolygons) {
    const mapData = mapHandler.getMap().data
    mapData.addGeoJson(prospectedAreaPolygons)
    mapData.setStyle({
      visible: false,
      strokeColor: '#21adbf',
      strokeOpacity: 0.6,
      strokeWeight: 1,
      fillColor: '#21adbf',
      fillOpacity: 0.25,
    })
  }

  function addCompanyMarkers(markers) {
    if (markers.length >= 1) {
      Gmaps.store = {}
      Gmaps.store.markers = markers.map((m) => {
        const marker = mapHandler.addMarker(m)
        marker.serviceObject.set('id', m.id)
        marker.serviceObject.set('name', m.name)
        marker.serviceObject.set('area_id', m.area_id)
        marker.serviceObject.set('size', m.size)
        marker.serviceObject.set('qualification_level', m.qualification_level)

        const mapData = mapHandler.getMap().data
        marker.serviceObject.addListener('mouseover', function () {
          this.setAnimation(google.maps.Animation.BOUNCE)
          mapData.overrideStyle(mapData.getFeatureById(m.area_id), {
            visible: true
          })
        })
        marker.serviceObject.addListener('mouseout', function () {
          this.setAnimation(null)
          mapData.overrideStyle(mapData.getFeatureById(m.area_id), {
            visible: false
          })
        })
        return marker
      })
      mapHandler.bounds.extendWith(Gmaps.store.markers)
      mapHandler.fitMapToBounds()
    }
  }

  function addCustomerMarkers(markers) {
    const marker = mapHandler.addMarker(markers[0])
    if (!Gmaps.store) {
      Gmaps.store = {
        markers: [],
      }
    }
    Gmaps.store.markers.push(marker)
    mapHandler.bounds.extendWith(Gmaps.store.markers)
    mapHandler.fitMapToBounds()
  }

  function filterMarkersList(size, qualificationLevel, name) {
    document.querySelectorAll('#map-markers-list li').forEach((markerLi) => {
      const sizeData = markerLi.dataset.size
      const qualificationLevelData = markerLi.dataset.qualificationLevel
      const nameData = markerLi.dataset.name

      if (
        (sizeData === size || !size) &&
        (qualificationLevelData === qualificationLevel || !qualificationLevel) &&
        (nameData && nameData.toLowerCase().includes(name.toLowerCase()) || !name.length)
      ) {
        markerLi.style.display = ''
      } else {
        markerLi.style.display = 'none'
      }
    })
  }

  function filterMarkers(size, qualificationLevel, name) {
    if (!Gmaps.store || !Gmaps.store.markers) return

    Gmaps.store.markers.forEach((marker) => {
      if (
        (marker.serviceObject.get('size') === size || !size) &&
        (marker.serviceObject.get('qualification_level') === qualificationLevel || !qualificationLevel) &&
        (marker.serviceObject.get('name').toLowerCase().includes(name.toLowerCase()) || !name.length)
      ) {
        marker.serviceObject.setVisible(true)
      } else {
        marker.serviceObject.setVisible(false)
      }
    })
  }

  function SidebarControl(controlDiv, map) {
    const sidebarContainer = document.querySelector('#map-sidebar-container')
    if (!sidebarContainer) return

    function createMarkerLi(marker) {
      const markerLi = document.createElement('li')
      const link = document.createElement('a')
      link.textContent = marker.serviceObject.title
      markerLi.appendChild(link)
      markerLi.dataset.size = marker.serviceObject.get('size')
      markerLi.dataset.qualificationLevel = marker.serviceObject.get('qualification_level')
      markerLi.dataset.name = marker.serviceObject.get('name')
      return markerLi
    }

    function bindToMarker(li, marker) {
      li.addEventListener('click', () => {
        map.setZoom(14)
        marker.setMap(map)
        marker.panTo()
        google.maps.event.trigger(marker.getServiceObject(), 'click')
      })
    }

    function addMarkersToList() {
      const markersList = sidebarContainer.querySelector('#map-markers-list')
      if (!markersList) return

      Gmaps.store.markers.forEach((marker) => {
        const li = createMarkerLi(marker)
        markersList.appendChild(li)
        bindToMarker(li, marker)
      })
    }

    function addToggleListeners() {
      const sidebarToggler = document.querySelector('#sidebar-toggler')
      const sidebarContent = document.querySelector('#map-sidebar-content')
      if (!sidebarToggler || !sidebarContent) return

      sidebarToggler.addEventListener('click', () => {
        sidebarToggler.style.display = 'none'
        sidebarContent.style.display = ''
      })

      const closeButton = document.querySelector('#sidebar-close-button')
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          sidebarContent.style.display = 'none'
          sidebarToggler.style.display = ''
        })
      }
    }

    function applyFilters() {
      const sizeInput = document.querySelector('input[name="size"]:checked')
      const qualificationLevelInput = document.querySelector('input[name="qualificationLevel"]:checked')
      const nameInput = document.querySelector('#company-name-filter-input')

      const size = sizeInput ? sizeInput.value : null
      const qualificationLevel = qualificationLevelInput ? qualificationLevelInput.value : null
      const name = nameInput ? nameInput.value : ''

      filterMarkersList(size, qualificationLevel, name)
      filterMarkers(size, qualificationLevel, name)
    }

    function addFilterListeners() {
      document.querySelectorAll('input[name="size"]').forEach((input) => {
        input.addEventListener('change', applyFilters)
      })

      document.querySelectorAll('input[name="qualificationLevel"]').forEach((input) => {
        input.addEventListener('change', applyFilters)
      })

      const nameInput = document.querySelector('#company-name-filter-input')
      if (nameInput) {
        nameInput.addEventListener('keyup', applyFilters)
      }
    }

    addMarkersToList()
    addToggleListeners()
    addFilterListeners()

    controlDiv.appendChild(sidebarContainer)
  }

  function PlaceSearchControl(controlDiv, map) {
    const searchInputContainer = document.querySelector('#map-search-input-container')
    if (!searchInputContainer) return

    let autocomplete

    function addMarker() {
      const place = autocomplete.getPlace()

      // Vérifier que le lieu a une géométrie valide
      if (!place || !place.geometry || !place.geometry.location) {
        console.warn('Place selection invalide ou sans géométrie')
        return
      }

      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng()
      const map = mapHandler.getMap()

      const marker = mapHandler.addMarker({
        title: place.formatted_address,
        lat: lat,
        lng: lng,
        infowindow: place.formatted_address,
      })
      Gmaps.store.markers.push(marker)

      mapHandler.bounds.extendWith(Gmaps.store.markers)
      mapHandler.fitMapToBounds()
      map.setCenter({ lat: lat, lng: lng })
      map.setZoom(14)
    }

    function initAutocomplete() {
      const input = searchInputContainer.querySelector('input')
      if (!input) return

      autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'] })
      autocomplete.addListener('place_changed', addMarker)
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
        }
      })
    }

    initAutocomplete()
    controlDiv.appendChild(searchInputContainer)
  }

  function addPlaceSearchControl() {
    const placeSearchControlDiv = document.createElement('DIV')
    const placeSearchControl = new PlaceSearchControl(placeSearchControlDiv, mapHandler.getMap())

    placeSearchControlDiv.index = 0
    mapHandler.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(placeSearchControlDiv)
  }

  function addSidebarControl() {
    const sidebarControlDiv = document.createElement('DIV')
    const sidebarControl = new SidebarControl(sidebarControlDiv, mapHandler.getMap())

    sidebarControlDiv.index = 1
    mapHandler.getMap().controls[google.maps.ControlPosition.LEFT].push(sidebarControlDiv)
  }

  const companyMarkers = JSON.parse(mapElement.dataset.companyMarkers || '[]')
  const customerMarkers = JSON.parse(mapElement.dataset.customerMarkers || '[]')
  const prospectedAreaPolygons = JSON.parse(mapElement.dataset.prospectedAreaPolygons || '[]')
  let markersConfig = {}

  if (companyMarkers.length > 1 && companyMarkers.length <= 5) {
    markersConfig = {
      randomize: true,
      maxRandomDistance: 10,
      clusterer: { maxZoom: 20, gridSize: 40 }
    }
  } else {
    markersConfig = { clusterer: undefined }
  }

  mapHandler = Gmaps.build('Google', { markers: markersConfig })

  mapHandler.buildMap(
    {
      provider: {
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
      },
      internal: {
        id: 'google-map',
      },
    },
    () => {
      if (
        (!companyMarkers || companyMarkers.length === 0) &&
        (!customerMarkers || customerMarkers.length === 0) &&
        (!prospectedAreaPolygons || prospectedAreaPolygons.length === 0)
      ) {
        return
      }

      addProspectedAreaPolygons(prospectedAreaPolygons)
      addCompanyMarkers(companyMarkers)

      if (customerMarkers) {
        addCustomerMarkers(customerMarkers)
      }

      if (companyMarkers.length > 1) {
        addSidebarControl()
      }
      addPlaceSearchControl()
    }
  )
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initMap)

